import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

import Button from 'components/Button';

const CardWithAction = ({
  cta,
  title,
  subtitle,
  to,
  onClick,
  callback,
  className,
  children,
  isDisabled,
  testId,
}) => {
  return (
    <div
      className={`card p-5 lg:p-12 mb-5 box-border ${className} ${
        isDisabled ? 'bg-gray-100 opacity-60' : ''
      } justify-between`}
      data-testid="container"
    >
      <div className="lg:mr-4 mb-4 lg:mb-0">
        <h3 className="text-javelin-gray-dark text-sm font-bold leading-8">
          {title}
        </h3>
        {!!subtitle && (
          <p className="text-javelin-gray-light text-sm lg:text-sm leading-6">
            {subtitle}
          </p>
        )}
      </div>
      {children}
      {!!to && (
        <Link
          className={`btn btn-primary py-3 h-12 text-base px-0 w-48 text-center ${
            isDisabled ? 'pointer-events-none opacity-70' : ''
          }`}
          data-testid={testId}
          to={to}
          onClick={callback}
        >
          {cta}
        </Link>
      )}
      {!!onClick && (
        <Button
          className="btn-primary h-12 text-base px-0 w-48 lg:self-end disabled:cursor-default"
          title={cta}
          onClick={onClick}
          isDisabled={isDisabled}
          testId={testId}
        />
      )}
    </div>
  );
};

CardWithAction.propTypes = {
  cta: PropTypes.string,
  title: PropTypes.string,
  subtitle: PropTypes.string,
  to: PropTypes.string,
  onClick: PropTypes.func,
  className: PropTypes.string,
  testId: PropTypes.string,
  isDisabled: PropTypes.bool,
};

CardWithAction.defaultProps = {
  className: 'flex flex-col lg:flex-row lg:h-40 lg:items-center',
  isDisabled: false,
  testId: 'button',
};
export default CardWithAction;
